(() => {
  const select = $("[name='variant_id']");

  $(document).on(
    "click",
    ".product-form-standardSelector .item:not(.disabled)",
    function () {
      // active state
      $(this).siblings(".item").removeClass("active");
      $(this).addClass("active");

      // update label (use Liquid-cleaned display)
      $(this)
        .closest(".option-wrapper")
        .find("label .sel")
        .text($(this).attr("data-display-title"));

      // ✅ ID-based selection (FINAL)
      const id = $(this).attr("data-option");

      console.log("Selected variant ID (from item):", id);

      select.val(id).trigger("change");
    }
  );

    $("[name='variant_id']").on("change", function () {
    const value = $(this).val();
    const option = $(this).find(`option[value='${value}']`);

    console.log("Selected variant ID:", value);
    console.log("Matched <option>:", option);
    console.log("data-bundled:", option.attr("data-bundled"));

    const url = new URL(window.location.href);
    url.searchParams.set("variant", value);
    window.history.replaceState(null, "", url.toString());

    const stockNum = option.attr("data-restock");
    const restock = option.attr("data-stockindicatornum");

    $("#currentSelection").attr("data-variant", value);
    $("#currentSelection").attr("data-price", option.attr("data-price"));
    $("#currentSelection").attr("data-bundled-variant-ids", option.attr("data-bundled"));
    $("#currentSelection").attr("data-compare", option.attr("data-compare"));
    $("#currentSelection").attr("data-voucher", option.attr("data-voucher"));
    $("#currentSelection").attr("data-restock", option.attr("data-restock"));
    $("#currentSelection").attr("data-stocknum", option.attr("data-stockindicatornum"));
    $(".popup-content .dynamicCode").text(option.attr("data-voucherText"));

    // 👇 this now uses title (not ID)
    $(".subtitle[data-variant_title]").text(option.attr("data-option") || "");

    updateLinks();
    updatePrice();
    updateInstallment();
    updateVoucher();
    
    toggleATCbuttons();
    updateImage();
    updateRestock();

    updateStockIndicator();

  });

  function toggleATCbuttons() {
    const atcButton = $("#AddToCart-button");
    const checkoutBtn = $("#initateCheckout");
    const soldOutBtn = $("#sold-out-btn");

    const selValue = $("[name='variant_id']").val();
    const selOption = $(`[name='variant_id'] option[value='${selValue}']`);

    if (selOption.attr("data-available") == "true") {
      atcButton.show();
      checkoutBtn.show();
      soldOutBtn.addClass("hide");
    } else {
      atcButton.hide();
      checkoutBtn.hide();
      soldOutBtn.removeClass("hide");
    }
    
    if (selOption.attr("data-preorder")) {
      //$("#initateCheckout").text("PRE-ORDER NOW");
    }
  }

  function updateImage() {
    const value = $("[name='variant_id']").val();
    const option = $(`[name='variant_id'] option[value='${value}']`);
    const handle = option.attr("data-handle");

    $(".product-single__thumbnails-items").removeClass("active");
    $(".product-single__thumbnails-items." + handle).addClass("active");

    $(".product-single__thumbnails-items.main a").removeClass("active-thumb");
    $(".product-single__thumbnails-items.main." + handle + " a").addClass(
      "active-thumb"
    );

    $(".product-single__thumbnails-items.main a.active-thumb").click();
  }

  toggleATCbuttons();
  updateImage();
})();

// trigger initial selection (layout2 only)
const initialItem = $(".product-form-standardSelector.layout2 .item.active").first();

if (initialItem.length) {
  initialItem.trigger("click");
}